import html2canvas from "html2canvas"
import dayjs from "dayjs"
import { generateReceipt } from "./API/PaymentApi/PaymentApi"

export const handleApiPrint = async (
  elementRef, 
  printerName, 
  trigger, 
  name, 
  paymentData, 
  isReprint, 
  invoicePayments
) => {
  try {
    // Convert HTML to canvas
    const canvas = await html2canvas(elementRef.current, {
      backgroundColor: "#ffffff",
      scale: 2,
    })

    // Extract queue number from the element
    const queueNumber = paymentData?.emr_queue_no || elementRef.current?.textContent?.match(/GP\d+/)?.[0] || ""
    
    // Convert canvas to text content for thermal printer
//     const textContent = `
// QUEUE SLIP
// NUMBER: ${queueNumber}
// CSR
// ${dayjs().format("MMM DD, YYYY hh:mm A")}
// PLEASE PROCEED TO EMR
// YOU WILL BE SERVED SHORTLY
// `.trim()
    
    // console.log("Text content being printed:", textContent)

    const element = elementRef.current;
    html2canvas(element, { scale: 1 }).then(async (canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const blob = new Blob([imgData], { type: "text/plain" });
        const textFile = new File([blob], name, { type: "text/plain" });
        
        await new Promise(resolve => setTimeout(resolve, 100))

        // Call the print API
        const response = await generateReceipt({
          printer: printerName,
          txtfile: textFile,
          open_cashdrawer: trigger,
          emr_queue_no: paymentData?.emr_queue_no || "",
          name: name
        })

        return response
    });
    
    // Create file
    // const blob = new Blob([textContent], { type: "text/plain" })
    // const textFile = new File([blob], "queueSlip.txt", { type: "text/plain" })

    // Small delay before API call (like working code)
    // await new Promise(resolve => setTimeout(resolve, 100))

    // // Call the print API
    // const response = await generateReceipt({
    //   printer: printerName,
    //   txtfile: textFile,
    //   open_cashdrawer: trigger,
    //   emr_queue_no: paymentData?.emr_queue_no || "",
    //   name: name
    // })
  } catch (error) {
    console.error("Print error:", error)
    return { error }
  }
}
